<div [class]="config?.cssClass ? config!.cssClass : ''">
  <div
    class="form-group"
    [formGroup]="formGroup!"
  >
    <label
      for="{{ config?.name }}"
      class="mb-1 fw-bold"
    >
      {{ config?.label }}

      @if (config ? showAsterisk(config) : false) {
        *
      }

      <ng-template #tooltip>
        <div [innerHtml]="config?.tooltip"></div>
      </ng-template>

      @if (config?.tooltip) {
        <i
          class="far fa-question-circle"
          [ngbTooltip]="tooltip"
        ></i>
      }
    </label>

    <input
      type="{{ config?.type === 'email' ? 'email' : config?.type === 'number' ? 'number' : config?.type === 'password' ? 'password' : 'text' }}"
      [attr.placeholder]="config?.placeholder"
      [attr.autocomplete]="config?.autocomplete"
      [formControlName]="config?.name ?? null"
      [class]="'form-control ' + (config?.inputClass ?? '')"
      [class.is-valid]="valid"
      [class.is-invalid]="invalid"
      [id]="config?.name"
      [attr.aria-describedby]="config?.name + 'err'"
      [attr.data-testid]="'form_'+config?.type+'_'+config?.name | slugify:'_'"
    />
    @if (config?.additionalText) {
      <small
        id="{{ config!.name + '-text' }}"
        class="form-text text-muted"
      >
        {{ config!.additionalText }}
      </small>
    }

    <div
      libFormFieldError
      [fieldConfig]="config!"
      [formComponent]="fc"
    ></div>
  </div>
</div>
